/**
 * Sets up the initial state of the store
 */
import verFlavor from "@/appFlavorAndVersion";


let defaultState = {
  // Application gobal settings, API base urls etc
  app_defaultOrganizationIdForFlavor: 1, // to be used to specify the organizationId until user authenticates
  app_apiURL: '', // base url for all the api endpoints
  app_botConfigurationUrl: '',
  app_boturl: '',
  app_s3url: '',
  app_s3privateUrl: '',
  appVersion: verFlavor.APP_VERSION,
  appBuildNumber: verFlavor.APP_BUILDNUMBER,
  userLoggedIn : false,
  logoutUserSession : false,
  isSSOLogin: false,
  tempLoggedIn : {},
  domainsList: [], //list of domians/goals in the organization 
  userCurrentDomain: '',
  userCurrentDomainName: '',
  isRefundPolicyPageActive: false, 
  tempLogInPhoneNumberData: {},
  learnHierarchyChildNodes: new Map(), //maps of Learn hierechy nodes (app hierarchy nodes)
  cloudFrontCookiesResponse: '',

  loginError: '', // indicates if any error is returned by sso token validation api
  userState : {},
  navDrawer: true,
  submitError : "",
  testSeriesState: {
    submissionData: {},
    clear: false
  },
  appBarVisible: false,
  navDrawerVisible: false,
  loading: false,
  isProfileVisible: false,
  profileInfo: {},
  profileInfoLoadedFromServer: false,
  deleteProfileError: '', // indicates if any error is returned while deleting
  
  //homeowrk
  homeworks: [],
  homeworksLoadedFromServer: false,
  homeworkDocumentS3Data : {},
  currentTestForHomeworkReport : {},

  //combinedTestReports
  combinedTestReports: [],
  testReportsForCombinedReport: {},
  studentCombinedTestReport:{},

  //test
  userTestCollections: [],
  userTestCollectionsLoadedFromServer: false,
  tests: [],
  testsLoadedFromServer: false,
  startTestLoadedFromServer: false,
  startTestInfo: {},
  currentTestJson: [],
  qResponsesState: [],
  selectedTest: {},
  syncTimerData: {},
  testRoutingAllowed: false,
  testReports: {},
  testReportsLoadedFromServer : false,
  currentTestResult: {},
  currentTestResultJson: [],
  currentTestResultLoadedFromServer: false,
  submissionInfo : {},
  currentTestId: "",
  currentTestState: {
    sectionIndex: 0,
    qIndex: 0
  },
  questionAttemptError: "",
  //classes
  classesList: [],
  classesListLoadedFromServer: false,
  userMessages: [],
  userMessagesLoadedFromServer: false,
  userMessageUpdated: false,

  //calendarecents
  calendarEvents:[],
  calendarEventsLoadedFromServer: false, 

  //network error
  errorSnackbar: false,

  //errorLogs
  errorLogs: JSON.parse(localStorage.getItem('errorLogs')) || [],
  networkErrorLogs: JSON.parse(localStorage.getItem('networkErrorLogs')) || [],
  testErrorLogs: JSON.parse(localStorage.getItem('testErrorLogs')) || [],
  featuresEnabled : {},

  //notifications
  unreadNotificationsCount: 0,

  //forms
  forms:[]
}


export default {
  ...defaultState
};
